import React from 'react';
import Loadable from 'react-loadable';
import { RouteComponentProps } from 'react-router';

import { getQueryFromLocation } from '../../../shared/utils/urls';

function BlankLoadingPage() {
  // This loading page should never be seen in production because this loading state only
  // happens on the server. We don't want to import the Widget loading page or the DI loading page
  // as that will increase the bundle size for the main bundle.
  return null;
}

const LoadableSchedulingPageV1 = Loadable({
  loader: () => import(/* webpackChunkName: "scheduling1" */ './SchedulingPageV1'),
  loading: () => <BlankLoadingPage />,
});

const LoadableSchedulingPageV2 = Loadable({
  loader: () => import(/* webpackChunkName: "scheduling2" */ './SchedulingPageV2'),
  loading: () => <BlankLoadingPage />,
});

type Params = { id: string };

export default function SchedulingPage(props: RouteComponentProps<Params>) {
  const { exp_schedule_request_v2 } = getQueryFromLocation(props.location);
  if (exp_schedule_request_v2 == null || exp_schedule_request_v2 === '') {
    return <LoadableSchedulingPageV1 {...props} />;
  }
  return <LoadableSchedulingPageV2 {...props} />;
}
